module.exports = __webpack_public_path__ + "static/media/sort-circle.2709cf39.svg";